import React, { useRef } from 'react';

function ReadyControl({
  isHost,
  isSpectator,
  isReady,
  readyPlayers,
  nonHostPlayers,
  readyCount,
  allReady,
  onTogglePlayerReady,
  onHostAction,
  hostActionLabel = 'Start',
  hostActionDisabled = false,
  hostActionTitle = '',
  hostCanStartSolo = false,
}) {
  const audioRef = useRef();
  const playSilentAudio = () => {
    if (audioRef.current) {
      audioRef.current.play().catch(() => {});
    }
  };
  return (
    <>
      <audio ref={audioRef} src="data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=" style={{ display: 'none' }} preload="auto" />
      {!isHost && !isSpectator && (
        <div className="mb-2 flex items-center gap-2">
          <button
            type="button"
            className={`w-full w-auto p-2 rounded text-white text-sm font-semibold ${
              isReady ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'
            }`}
            style={{ minWidth: 0, }}
            onClick={() => { playSilentAudio(); onTogglePlayerReady(); }}
          >
            {isReady ? 'I\'m not ready!' : 'I\'m Ready!'}
          </button>
        </div>
      )}

      {isHost && (
        <div className="mb-2">
          <div className="text-sm mb-1 text-gray-700 dark:text-gray-200">
            {nonHostPlayers.length === 0
              ? hostCanStartSolo
                ? 'You can start this game on your own.'
                : 'Waiting for players to join...'
              : allReady
              ? 'All players are ready!'
              : `${readyCount} / ${nonHostPlayers.length} of other players ready`}
          </div>
          <button
            type="button"
            className={`w-full p-2 rounded mt-2 text-white text-sm font-semibold ${
              hostActionDisabled ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'
            }`}
            style={{ minWidth: 0 }}
            disabled={hostActionDisabled}
            title={hostActionTitle}
            onClick={() => {
              if (!hostActionDisabled && typeof onHostAction === 'function') {
                playSilentAudio();
                onHostAction();
              }
            }}
          >
            {hostActionLabel}
          </button>
        </div>
      )}
    </>
  );
}

export default ReadyControl;
